import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store";

export interface GeneralState {
  cookieSettingsDialogState: boolean;
  termsOfUseDialogState: boolean;
  seenCookieSettings: boolean;
  responsiveDrawerState: boolean;
}

const initialState: GeneralState = {
  cookieSettingsDialogState: false,
  termsOfUseDialogState: false,
  seenCookieSettings: false,

  responsiveDrawerState: false,
};

export const general = createSlice({
  name: "general",
  initialState,
  reducers: {
    setCookieSettingsDialogState: (state, action: PayloadAction<boolean>) => {
      state.cookieSettingsDialogState = action.payload;
    },
    setTermsOfUseDialogState: (state, action: PayloadAction<boolean>) => {
      state.termsOfUseDialogState = action.payload;
    },
    setResponsiveDrawerState: (state, action: PayloadAction<boolean>) => {
      state.responsiveDrawerState = action.payload;
    },
  },
});

export const { setCookieSettingsDialogState, setTermsOfUseDialogState, setResponsiveDrawerState } =
  general.actions;

export const selectCookieSettingsDialogState = (state: RootState) =>
  state.general.cookieSettingsDialogState;

export const selectTermsOfUseDialogState = (state: RootState) =>
  state.general.termsOfUseDialogState;

export const selectResponsiveDrawerState = (state: RootState) =>
  state.general.responsiveDrawerState;

export default general.reducer;
